import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Container = styled.div`
  display: flex;
  flex: 1;
  color: rgba(0, 0, 0, 0.54);
  gap: 10px;
`

export const flex = css`
  display: flex;
  align-items: center;
`

export const lastSavedContainer = css`
  flex: 1;
`

export const viewOptionsContainer = css``

export const rowModeSelector = css``
